const pl = {
  pleaseEnterUsername: "Proszę podać nazwę użytkownika",
  cannotFriendYourself: "Nie możesz wysłać zaproszenia do znajomych samemu sobie.",
  friendRequestSent: "Zaproszenie do znajomych zostało wysłane!",
  failedToSendRequest: "Nie udało się wysłać zaproszenia",
  linkCopied: "Link został skopiowany do schowka!",
  backToInvites: "Powrót do zaproszeń",
  sendFriendRequestByUsername: "Wyślij zaproszenie do znajomych przez nazwę użytkownika",
  enterUsername: "Wprowadź nazwę użytkownika",
  send: "Wyślij",
  yourInviteQrCode: "Twój kod QR zaproszenia",
  inviteLink: "Link zaproszenia",
  scanQrOrUseLink: "Zeskanuj ten kod QR lub użyj tego linku, aby wysłać zaproszenie do znajomych",
  copyInviteLink: "Kopiuj link zaproszenia",
  goToItem: "Przejdź do elementu",
  verificationEmailSent: "E-mail weryfikacyjny został wysłany! Sprawdź swoją skrzynkę odbiorczą.",
  verificationEmailFailed: "Nie udało się wysłać e-maila weryfikacyjnego. Spróbuj ponownie.",
  verifyYourEmail: "Zweryfikuj swój adres e-mail",
  verifyEmailInstructions: "Proszę zweryfikować swój adres e-mail, aby uzyskać dostęp do konta. Sprawdź skrzynkę odbiorczą w poszukiwaniu linku weryfikacyjnego.",
  sending: "Wysyłanie...",
  resendVerificationEmail: "Wyślij ponownie e-mail weryfikacyjny",
  login: "Zaloguj się",
  register: "Zarejestruj się",
  home: "Strona główna",
  calendar: "Kalendarz",
  friends: "Znajomi",
  profile: "Profil",
  logout: "Wyloguj się",
  loading: "Ładowanie...",
  language: "Język",
  calendarSelectPlaceSuggestion: "Wybierz miejsce z podpowiedzi, aby dołączyć współrzędne.",
  calendarSelectDateAndTime: "Wybierz datę i godzinę.",
  calendarPositiveDuration: "Podaj dodatni czas trwania.",
  calendarFutureDateRequired: "Data i godzina wydarzenia muszą być w przyszłości.",
  calendarCreateEventFailed: "Nie udało się utworzyć wydarzenia. Spróbuj ponownie.",
  cancel: "Anuluj",
  createNewEvent: "Utwórz nowe wydarzenie",
  week: "Tydzień",
  month: "Miesiąc",
  eventTitle: "Tytuł",
  date: "Data",
  time: "Godzina",
  duration: "Czas trwania",
  endsAt: "Kończy się o",
  place: "Miejsce",
  searchForPlace: "Szukaj miejsca",
  placeSearchTip: "Wskazówka: zacznij pisać i wybierz wynik, aby dołączyć współrzędne.",
  description: "Opis",
  createEvent: "Utwórz wydarzenie",
  today: "Dzisiaj",
  previousMonth: "Poprzedni miesiąc",
  nextMonth: "Następny miesiąc",
  previous: "Poprzedni",
  next: "Następny",
  mondayShort: "Pon",
  tuesdayShort: "Wt",
  wednesdayShort: "Śr",
  thursdayShort: "Czw",
  fridayShort: "Pt",
  saturdayShort: "Sob",
  sundayShort: "Niedz",
  more: "więcej",
  mustRespondWillBeforeReposting: "Musisz wybrać „Wezmę udział”, zanim ponownie udostępnisz",
  event: "Wydarzenie",
  backToCalendar: "Powrót do kalendarza",
  addToGoogleCalendar: "Dodaj do Kalendarza Google",
  when: "Kiedy",
  where: "Gdzie",
  openLocationInGoogleMaps: "Otwórz lokalizację w Mapach Google",
  hosts: "Organizatorzy",
  yourResponse: "Twoja odpowiedź",
  currentResponse: "Aktualna odpowiedź",
  response_will: "Wezmę udział",
  response_might: "Może wezmę udział",
  response_wont: "Nie wezmę udziału",
  willRunIntoYou: "Wpadnę",
  mightDropBy: "Może wpadnę",
  wontCome: "Nie przyjdę",
  repostToMyFriends: "Udostępnij moim znajomym",
  responses: "Odpowiedzi",
  willAttend: "Weźmie udział",
  reposted: "Udostępniono ponownie",
  mightAttend: "Może weźmie udział",
  cancelEvent: "Anuluj wydarzenie",
  cancellationEmailNoticeBefore: "Osoby, które potwierdziły udział",
  cancellationEmailNoticeAfter: "otrzymają wiadomość e-mail z informacją o odwołaniu wydarzenia.",
  optionalCancellationMessage: "Opcjonalna wiadomość dla uczestników (maksymalnie 1000 znaków)",
  confirmCancelEvent: "Potwierdź anulowanie wydarzenia",
  clear: "Wyczyść",
  confirmCancellation: "Potwierdź anulowanie",
  confirmCancellationMessage: "Czy na pewno chcesz anulować to wydarzenie? Powiadomi to potwierdzonych uczestników i usunie wydarzenie.",
  eventCancelledNotified: "Wydarzenie anulowane. Powiadomiono",
  attendees: "uczestników",
  failedToCancelEvent: "Nie udało się anulować wydarzenia",
  back: "Wstecz",
  cancelled: "Anulowano",
  ok: "OK",
  forgotPassword: "Nie pamiętasz hasła",
  email: "E-mail",
  passwordResetLinkSent: "Jeśli konto istnieje, wysłano link do resetowania hasła.",
  passwordResetRequestFailed: "Nie udało się wysłać prośby o reset hasła.",
  sendResetLink: "Wyślij link do resetowania",
  addFriend: "Dodaj znajomego",
  incomingRequests: "Przychodzące zaproszenia",
  accept: "Akceptuj",
  deny: "Odrzuć",
  myFriends: "Moi znajomi",
  noFriendsYet: "Nie masz jeszcze znajomych. Zacznij ich dodawać!",
  seeProfile: "Zobacz profil",
  noEventsToRespondTo: "Brak wydarzeń wymagających odpowiedzi",
  allCaughtUp: "Wszystko jest aktualne. Wróć później, aby zobaczyć nowe wydarzenia od znajomych.",
  events: "Wydarzenia",
  unknown: "Nieznane",
  noDescriptionProvided: "Nie podano opisu.",
  will: "Tak",
  maybe: "Może",
  wont: "Nie",
  userNotFound: "Nie znaleziono użytkownika",
  friendRequestSentSuccessfully: "Zaproszenie do znajomych zostało wysłane!",
  friendInvitation: "Zaproszenie do znajomych",
  sendFriendRequest: "Wyślij zaproszenie do znajomych",
  loginToSendFriendRequest: "Zaloguj się, aby wysłać zaproszenie do znajomych",
  chooseLanguage: "Wybierz język",
  invalidCredentials: "Nieprawidłowe dane logowania. Spróbuj ponownie.",
  username: "Nazwa użytkownika",
  password: "Hasło",
  forgotPasswordQuestion: "Nie pamiętasz hasła?",
  dontHaveAccount: "Nie masz konta?",
  registerHere: "Zarejestruj się tutaj",
  invalidProfilePhotoType: "Nieprawidłowy typ pliku. Prześlij obraz JPEG, PNG, GIF lub WebP.",
  invalidFileExtension: "Nieprawidłowe rozszerzenie pliku",
  allowedExtensions: "Dozwolone",
  fileTooLarge: "Plik jest za duży",
  maximumFileSize: "Maksimum",
  profilePhotoRemoved: "Zdjęcie profilowe zostało usunięte.",
  failedToRemoveProfilePhoto: "Nie udało się usunąć zdjęcia profilowego",
  profileUpdatedSuccessfully: "Profil został pomyślnie zaktualizowany!",
  failedToUpdateProfile: "Nie udało się zaktualizować profilu",
  privateEmailExplanation: "Tylko Ty możesz zobaczyć swój adres e-mail, aby uniknąć niechcianych wiadomości poza platformą",
  yourEmailIsPrivate: "Twój adres e-mail jest prywatny.",
  profilePhoto: "Zdjęcie profilowe",
  removePhoto: "Usuń zdjęcie",
  firstName: "Imię",
  lastName: "Nazwisko",
  tellPeopleAboutYourself: "Powiedz coś o sobie",
  whereToContactMe: "Jak się ze mną skontaktować",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "Zapisz",
  notSet: "Nie ustawiono",
  editProfile: "Edytuj profil",
  imageToCrop: "Obraz do przycięcia",
  zoom: "Powiększenie",
  usePhoto: "Użyj zdjęcia",
  name: "Imię i nazwisko",
  whereToContact: "Kontakt",
  removeFriendship: "Usuń znajomego",
  confirmRemoveFriend: "Potwierdź usunięcie znajomego",
  confirmRemoveFriendBefore: "Czy na pewno chcesz usunąć",
  confirmRemoveFriendAfter: "z listy znajomych?",
  friendRemoved: "Znajomy został usunięty.",
  failedToRemoveFriend: "Nie udało się usunąć znajomego.",
  confirmRemove: "Potwierdź usunięcie",
  error: "Błąd",
  removed: "Usunięto",
  passwordsDoNotMatch: "Hasła nie są takie same",
  registrationFailed: "Rejestracja nie powiodła się. Spróbuj ponownie.",
  confirmPassword: "Potwierdź hasło",
  alreadyHaveAccount: "Masz już konto?",
  loginHere: "Zaloguj się tutaj",
  passwordResetSuccessfully: "Hasło zostało pomyślnie zresetowane.",
  failedToResetPassword: "Nie udało się zresetować hasła.",
  resetPassword: "Resetuj hasło",
  newPassword: "Nowe hasło",
  confirmNewPassword: "Potwierdź nowe hasło",
  setNewPassword: "Ustaw nowe hasło",
  emailVerifiedSuccessfully: "Adres e-mail został pomyślnie zweryfikowany!",
  emailVerificationFailed: "Weryfikacja nie powiodła się. Link może być nieprawidłowy lub wygasł.",
  verifying: "Trwa weryfikacja...",
  verified: "Zweryfikowano!",
  redirectingToHome: "Przekierowywanie do strony głównej...",
  verificationFailed: "Weryfikacja nie powiodła się",
  goToHome: "Przejdź do strony głównej",
  about: "O aplikacji",
  aboutConceptTitle: "Koncepcja",
  aboutCreatorIntroduction: "Cześć, jestem Crypt0, wspinaczem i twórcą Run Into Me.",
  aboutCreatorStory: "Stworzyłem tę stronę, ponieważ lubię ludzi i poświęcałem zbyt dużo czasu na organizowanie wspólnych wspinaczek.",
  aboutPlanningProblem: "Chciałem jednocześnie informować wszystkich, kiedy i gdzie będę się wspinać, bez formalnego zaproszenia.",
  aboutDeveloperSolution: "Wtedy przypomniałem sobie, że jestem programistą i mogę sam stworzyć rozwiązanie.",
  aboutWelcome: "Witamy w Run Into Me, gdzie informujesz znajomych o aktywnościach, do których mogą dołączyć bez presji.",
  aboutCallToAction: "Opublikuj tutaj następną aktywność, która jest przyjemniejsza razem!",
  aboutTutorialTitle: "Samouczek",
  aboutCalendarCreateEvent: "Na ekranie kalendarza możesz także utworzyć nowe wydarzenie.",
  aboutEventColorsIntroduction: "Kolory wskazują status udziału:",
  aboutColorGold: "Złoty",
  aboutColorGoldDescription: "Organizujesz to wydarzenie.",
  aboutColorGreen: "Zielony",
  aboutColorGreenDescription: "Bierzesz udział.",
  aboutColorOrange: "Pomarańczowy",
  aboutColorOrangeDescription: "Odpowiedź: „może”.",
  aboutColorBlue: "Niebieski",
  aboutColorBlueDescription: "Brak odpowiedzi.",
  aboutColorGray: "Szary",
  aboutColorGrayDescription: "Zaproszenie odrzucone.",
  aboutCalendarEventDetails: "Kliknij wydarzenie, aby zobaczyć szczegóły i odpowiedzieć.",
  aboutFriendPageTitle: "Strona znajomych",
  aboutFriendPageDescription: "Wpisz nazwę użytkownika lub wyślij łącze / kod QR.",
  aboutHomePageTitle: "Strona główna",
  aboutHomePageDescription: "Przeglądaj wydarzenia i informuj, czy przyjdziesz.",
  aboutRepostScreenTitle: "Ekran ponownego udostępniania",
  aboutGoogleCalendarDescription: "Dodaj wydarzenie do Kalendarza Google tym przyciskiem.",
  aboutRepostDescription: "Po potwierdzeniu udziału możesz udostępnić wydarzenie znajomym.",
};

export default pl;